module.exports = __webpack_public_path__ + "static/other/jigsaw_puzzle_game.cd8e68b2.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/jigsaw_puzzle_game.json
// module id = 2463
// module chunks = 0